import { useFormatter } from 'next-intl';

export default function FormatterKm(distance: number): string {
  const format = useFormatter();

  const formattedKm = format.number(distance, {
    style: 'unit',
    unit: 'kilometer',
    unitDisplay: 'short',
  });

  return formattedKm;
}

export function FormatterInteger(distance: number): string {
  const format = useFormatter();

  const formatted = format.number(distance, {
    style: 'decimal',
  });

  return formatted;
}
